<div class="dialog-header">
  <h2 mat-dialog-title>Session expiring soon</h2>
  <button mat-icon-button class="close-button" type="button" (click)="staySignedIn()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>
    You've been inactive for a while. You will be signed out in
    <strong>{{ countdownSeconds }}</strong>
    seconds unless you choose to stay signed in.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="signOutNow()">Sign out</button>
  <button mat-raised-button color="primary" (click)="staySignedIn()">
    Stay signed in
  </button>
</mat-dialog-actions>